(() => {
  try {
    const norm = (s) =>
      (s || "").toString().trim().toLowerCase().replace(/\s+/g, " ");

    const sp = new URLSearchParams(location.search);
    const rawFilter = sp.get("filter.p.vendor") || "";
    const rawLuna = sp.get("luna_vendor") || "";

    const filterVendor = decodeURIComponent(rawFilter.replace(/\+/g, " ")).trim();
    const lunaVendor = decodeURIComponent(rawLuna.replace(/\+/g, " ")).trim();
    const vendor = (filterVendor || lunaVendor || "").trim();
    if (!vendor) return;

    // ✅ Eğer sadece luna_vendor varsa, 1 kere filter.p.vendor ekleyip reload
    const didRedirect = sp.get("luna_autofilter") === "1";
    if (!filterVendor && lunaVendor && !didRedirect) {
      const url = new URL(location.href);
      url.searchParams.set("filter.p.vendor", lunaVendor);
      url.searchParams.set("luna_vendor", lunaVendor);
      url.searchParams.set("luna_autofilter", "1");
      location.replace(url.pathname + "?" + url.searchParams.toString());
      return;
    }

    const target = norm(vendor);

    const findMarkaArea = () => {
      // Önce "MARKA" başlığını bul, en yakın kartını seç
      const heads = [...document.querySelectorAll("h1,h2,h3,h4,div,span")];
      const h = heads.find((el) => norm(el.textContent) === "marka");
      if (!h) return document;
      return h.closest("section, .filter-card, .luna-card, div") || document;
    };

    const removePaint = (scope) => {
      [...scope.querySelectorAll("[data-luna-tick='1']")].forEach((n) => n.remove());
      [...scope.querySelectorAll("[data-luna-selected='1']")].forEach((n) => {
        n.removeAttribute("data-luna-selected");
        n.style.background = "";
        n.style.borderColor = "";
        n.style.color = "";
        n.style.position = "";
      });
    };

    const paint = (btn) => {
      if (!btn) return false;

      // Filtreyi temizle satırına dokunma
      if (norm(btn.textContent) === "filtreyi temizle") return false;

      const scope = btn.closest("section, .filter-card, .luna-card, div") || document;
      removePaint(scope);

      btn.setAttribute("data-luna-selected", "1");
      btn.style.background = "#9ED9FF";
      btn.style.borderColor = "#9ED9FF";
      btn.style.color = "#0B1B2B";
      btn.style.position = "relative";

      const tick = document.createElement("span");
      tick.setAttribute("data-luna-tick", "1");
      tick.textContent = "✓";
      tick.style.position = "absolute";
      tick.style.right = "10px";
      tick.style.top = "50%";
      tick.style.transform = "translateY(-50%)";
      tick.style.fontWeight = "900";
      tick.style.fontSize = "14px";
      tick.style.lineHeight = "1";
      tick.style.color = "#0B1B2B";
      btn.appendChild(tick);

      if (btn.scrollIntoView) btn.scrollIntoView({ block: "nearest" });
      return true;
    };

    const bindClear = () => {
      const root = findMarkaArea();
      const clearEls = [...root.querySelectorAll("button,a,div,span")].filter((el) => {
        const t = norm(el.textContent);
        return t === "filtreyi temizle" || t === "filtreleri temizle" || t === "temizle";
      });

      clearEls.forEach((el) => {
        if (el.__lunaClearBound) return;
        el.__lunaClearBound = true;

        el.addEventListener(
          "click",
          () => {
            try {
              const url = new URL(location.href);
              url.searchParams.delete("luna_vendor");
              url.searchParams.delete("filter.p.vendor");
              url.searchParams.delete("vendor");
              url.searchParams.delete("luna_autofilter");
              location.href =
                url.pathname +
                (url.searchParams.toString() ? "?" + url.searchParams.toString() : "");
            } catch (e) {}
          },
          true
        );
      });
    };

    const findAndSelect = () => {
      bindClear();

      const area = findMarkaArea();

      // ✅ Önce gerçek tıklanabilir satırları hedefle (button/label/role=button)
      const clickables = [...area.querySelectorAll("button,label,[role='button']")];
      const hit1 =
        clickables.find((el) => norm(el.textContent) === target) ||
        clickables.find((el) => norm(el.textContent).includes(target));

      if (hit1) {
        // seçim state'ini oturtmak için click
        try { hit1.click(); } catch (e) {}
        return paint(hit1);
      }

      // bazı temalarda clickable değil div oluyor; en yakın clickable parent'ı bul
      const all = [...area.querySelectorAll("*")].filter((el) => {
        const t = norm(el.textContent);
        return t && t.length <= 60;
      });

      const node =
        all.find((el) => norm(el.textContent) === target) ||
        all.find((el) => norm(el.textContent).includes(target));

      if (!node) return false;

      const btn =
        node.closest("button,label,[role='button']") ||
        node.closest("div") ||
        node;

      try { btn.click(); } catch (e) {}
      return paint(btn);
    };

    // ✅ Köpekte geç render/yeniden render: uzun süre MutationObserver ile yakala
    const start = Date.now();
    const maxMs = 45000; // 45sn

    const tick = () => {
      findAndSelect();
      if (Date.now() - start > maxMs) {
        try { obs.disconnect(); } catch (e) {}
      }
    };

    const obs = new MutationObserver(() => tick());
    obs.observe(document.documentElement, { childList: true, subtree: true });

    // ilk deneme + aralıklı deneme
    tick();
    const int = setInterval(() => {
      tick();
      if (Date.now() - start > maxMs) clearInterval(int);
    }, 400);
  } catch (e) {}
})();
